import { useState } from "react";
import DropDownJ from "../components/DropDownJ";
import MyNav from "../components/MyNav";
import FooterHome from '../components/FooterHome';
import TextBoxJ from "../components/TextBoxJ";
import { useNavigate } from "react-router";
import axios from "axios";

export default function FormPage({ isSmallScreen }) {
    const headerSty = "text-[2.5rem] mt-[4rem] font-semibold font-playfair text-left";
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        projectType: "",
        numberOfPages: "",
        keyFeatures: "",
        projectDescription: "",
        budget: "",
        timeline: "",
        maintenance: false,
        name: "",
        email: "",
        phone: "",
        additionalNotes: ""
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const mappedData = {
            'Project Type': formData.projectType,
            'Number Of Pages': formData.numberOfPages,
            'Key features': formData.keyFeatures,
            'Project Description': formData.projectDescription,
            'Budget': formData.budget,
            'Timeline': formData.timeline,
            'maintenance': formData.maintenance,
            'name': formData.name,
            'email': formData.email,
            'phone': formData.phone,
            'Additional Notes': formData.additionalNotes,
        };

        try {
            setLoading(true);
            const formUrl = process.env.REACT_APP_FORM;
            if (!formUrl) {
                alert('Form submission endpoint not configured.');
                setLoading(false);
                return;
            }
            const response = await axios.post(formUrl, mappedData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 200) {
                navigate('/success');
            } else {
                console.error('Form submission failed');
                alert('Submission failed. Please try again later.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="overflow-hidden text-[1.3rem]">
            <MyNav startB={true} isSmallScreen={isSmallScreen} />
            <div className="px-[30px] sm:px-[150px] mt-[7rem]">
                <p className="text-[3rem] font-semibold font-playfair text-left">
                    Get Started with Your Project
                </p>
                <div className="px-6">
                    <p className="flex mt-[5rem] justify-center items-center font-montserrat">
                        Welcome! We're excited to help you bring your project to life. Please fill out the form below with your requirements, and we'll get back to you shortly with a tailored proposal.
                    </p>
                    <form onSubmit={handleSubmit}>
                        <div className="sm:flex sm:space-x-[10rem]">
                            <DropDownJ title={"Project Type"} v1={"Static"} v2={"Fullstack"} v3={"App"} t1={"Static Website"} t2={"Fullstack Website"} t3={"Mobile Application"} name="projectType" onChange={handleChange} />
                            <DropDownJ title={"Number Of Pages"} v1={"1-5"} v2={"6-10"} v3={"11-20"} v4={"+20"} t1={"1-5"} t2={"6-10"} t3={"11-20"} t4={"+20"} name="numberOfPages" onChange={handleChange} />
                        </div>
                        <TextBoxJ title={"Key features"} placeholder={"Type out features that stand out about your project..."} height={4} name="keyFeatures" onChange={handleChange} />
                        <TextBoxJ title={"Project Description"} placeholder={"Express everything here..."} height={10} name="projectDescription" onChange={handleChange} />
                        <div className="flex space-x-[10rem]">
                            <DropDownJ title={"Budget"} v1={'under $500'} v2={"$500 - $1000"} v3={"$1000 - $5,000"} v4={"$5,000 - $10,000"} v5={"$10,000+"} t1={'under $500'} t2={"$500 - $1000"} t3={"$1000 - $5,000"} t4={"$5,000 - $10,000"} t5={"$10,000+"} name="budget" onChange={handleChange} />
                            <DropDownJ title={"Timeline"} v1={'less than a month'} v2={"1-2 months"} v3={"2-3 months"} v4={"3-6 months"} v5={"More than 6 months"} t1={'less than a month'} t2={"1-2 months"} t3={"2-3 months"} t4={"3-6 months"} t5={"More than 6 months"} name="timeline" onChange={handleChange} />
                        </div>
                        <label className="flex items-center mt-[3rem]">
                            <p className=" font-montserrat">Would you like to have our maintenance service?</p>
                            <input type="checkbox" className="w-[1.3rem] h-[1.3rem] ml-1 rounded-2xl" name="maintenance" onChange={handleChange} />
                        </label>
                        
                        <p className=" w-fit font-montserrat text-jabelDark text-[1rem] hover:underline hover:cursor-pointer" onClick={() => { navigate('/maintenance') }}>Don't know what that is? check it out here!</p>
                        <p className={headerSty}>
                            Contacts
                        </p>
                        <input className=" rounded font-montserrat w-full sm:w-[40vw] mt-10" placeholder="Name" type="text" name="name" onChange={handleChange}></input>
                        <input className=" rounded font-montserrat w-full sm:w-[40vw] mt-2 invalid:border-red-500" placeholder="Email" type="email" name="email" onChange={handleChange}></input>
                        <p className={headerSty}>
                            Additional Notes
                        </p>
                        <TextBoxJ placeholder={"Type here..."} height={8} name="additionalNotes" onChange={handleChange} />
                        <button
                            type="submit"
                            disabled={loading}
                            className={`text-[32px] w-full font-playfair p-5 mt-[7rem] mb-[3rem] rounded-lg text-white flex justify-center items-center ${loading ? 'bg-gray-600 cursor-not-allowed' : 'bg-black hover:bg-gray-900'}`}
                        >
                            {loading ? 'Submitting...' : 'Submit'}
                        </button>
                    </form>
                </div>
            </div>
            <FooterHome isSmallScreen={isSmallScreen} />
        </div>
    );
}
